export default __webpack_public_path__ + "static/media/Wood.49f7ad7c.jpg";